import {

  //ACTION_CARGUES,
  //ACTION_DOWNLOANDS,
  //ACTION_CARGUE_EXCEL
} from "@/views/cargues/store/types/types.js";




// import config from "@/views/cargues/config/cargues_api.js";
// import PathUri from '@/utils/path_uri';
// import axios from '@/plugins/http/axios.js';
// import Swal from 'sweetalert2';
// import moment from 'moment';

// const _pathUri = new PathUri(config.port, config.context);

const actions= {

    // [ACTION_DOWNLOANDS]: () => {

    //   /*DateFormat dateFormatter = new SimpleDateFormat("yyyy-MM-dd_HH:mm:ss");

    //   String currentDateTime = dateFormatter.format(new Date());
      
    //   filename=ll.bflex.plantillaCargue_" + currentDateTime + ".xlsx";*/
    //   const currentDateTime = moment().format('YYYY-MM-DD_HH:mm:ss');
    //   const filename = `ll.bflex.plantillaCargue_${currentDateTime}.xlsx`;

    //   return new Promise((resolve, reject) => {
    //     Swal.fire({
    //       title: 'Descargando...',
    //       text: 'El archivo quedará guardado en la carpeta de descargas',
    //       allowOutsideClick: false,
    //       didOpen: async () => {
    //         Swal.showLoading();
    //         try {
    //           const response = await axios({
    //             method: 'get',
    //             url: `${config.baseUrl + _pathUri.generateUri() + 'template/generar-template-carga-mil'}`,
    //             responseType: 'blob'
    //           })
    //           const blob = new Blob([response.data]);
    //           const url = URL.createObjectURL(blob);

    //           const link = document.createElement('a');
    //           link.href = url;
    //           link.download = filename;

    //           link.click();
    //           URL.revokeObjectURL(url);
    //           resolve(response.data)
    //           Swal.close();

    //         }
    //         catch (error) {
    //           Swal.close();
    //           reject(error)
    //           console.error('Error al obtener los datos:', error);
    //         }
    //       }
    //     });
    //   })
    // },

    // [ACTION_CARGUES]: (_, email) => {
    //   return new Promise((resolve, reject) => {

    //     const formData = new FormData();
    //     formData.append('file', email.selectedFile);
    //     axios.post(`${config.baseUrl + _pathUri.generateUri() + 'loader/cargue-empresas-nuevas'}`, formData, {
    //       headers: {
    //         'Content-Type': 'multipart/form-data',
    //         'email': email.email
    //       },
    //       responseType: 'blob'
    //     }).then(response => {
    //       const contentDisposition = response.headers['content-disposition'];
    //       let filename = 'resultado_cargue.xlsx';

    //       if (contentDisposition) {
    //         const matches = contentDisposition.match(/filename="?(.+)"?/);
    //         if (matches && matches.length > 1) {
    //           filename = matches[1];
    //         }
    //       }

    //       filename = filename.substring(0, filename.length - 1);
    //       const url = window.URL.createObjectURL(new Blob([response.data]));
    //       const link = document.createElement('a');
    //       link.href = url;
    //       link.setAttribute('download', filename);
    //       document.body.appendChild(link);
    //       link.click();
    //       document.body.removeChild(link);
    //       resolve(response.data)
    //     })
    //       .catch(error => {
    //         const contentDisposition = error.headers['content-disposition'];
    //         let filename = 'resultado_cargue.xlsx';

    //         if (contentDisposition) {
    //           const matches = contentDisposition.match(/filename="?(.+)"?/);
    //           if (matches && matches.length > 1) {
    //             filename = matches[1];
    //           }
    //         }
    //         // Quitar el último carácter del nombre de archivo
    //         filename = filename.substring(0, filename.length - 1);
    //         const url = window.URL.createObjectURL(new Blob([error.data]));
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.setAttribute('download', filename);
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //         reject(error)

    //       })
    //   });
    // },
/*
    [ACTION_CARGUE_EXCEL]: async ({ state }, excelFile) => {
        try {
          state.loading = true;
      
          const formData = new FormData();
          formData.append('excelFile', excelFile);
          // const response = await axios.post(
          //   `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/cargar-excel/`,
          //   formData,
          //   {
          //     headers: {
          //       'Content-Type': 'multipart/form-data',
          //       'idEmpresa': sessionStorage.getItem("idEmpresa"),
          //       'idUsuario': sessionStorage.getItem("idUsuario")
          //     }
          //   }
          // );
      
          // if (response && response.status === 200) {
          //   Swal.fire({
          //     position: 'top-end',
          //     icon: 'success',
          //     title: 'El archivo Excel fue cargado exitosamente',
          //     showConfirmButton: false,
          //     timer: 2500
          //   });
          //   return response.data;
          // } else {
          //   console.error("La petición fue incorrecta o falló");
          //   return Promise.reject("La petición fue incorrecta o falló");
          // }
        } catch (error) {
          console.error("Error en la solicitud:", error);
          return Promise.reject(error);
        } finally {
          state.loading = false;
        }
    },*/
      

}

export default actions